
define(
	'Code25.CaterpartsGlobal.KeyMapping'
	, [
		"Tools"
	]
	, function (
		Tools
	) {
		'use strict';



		return {
			mount: function mount(container) {
				function findComponentStock(item) {
					var custitem_c25_componentstocklevel = item.get("custitem_c25_componentstocklevel");
					if (custitem_c25_componentstocklevel) {
						return parseInt(custitem_c25_componentstocklevel || "0");
					}
					var _matrixParent = item.get("_matrixParent");
					if (_matrixParent) {

						var _matrixChilds = _matrixParent.get("_matrixChilds");
						if (_matrixChilds) {
							var itemid = item.get("itemid"), child;

							for (var i = 0; i < _matrixChilds.length; i++) {
								child = _matrixChilds.models[i];
								if (child.get("itemid") == itemid) {
									return parseInt(child.get("custitem_c25_componentstocklevel") || "0");
								}
							}
						}

					}
					return 0;
				}



				var hStocks = {};
				var hRenders = {};

				function quantityavailable(item) {

					var itemtype = item.get("itemtype");
					var quantityavailable_detail = item.get("quantityavailable_detail") || { quantityavailable: 0 };
					var quantitybackordered_detail = item.get("quantitybackordered_detail") || { quantitybackordered: 0 };
					var stock = Math.max(0, quantityavailable_detail.quantityavailable - quantitybackordered_detail.quantitybackordered);

					if (itemtype == "Assembly") {

						// if (!Tools.isLive()) {
						var cStock = findComponentStock(item);
						return Math.max(cStock, stock);
						// } else {
						// 	var internalid = item.get("internalid");

						// 	if (internalid && typeof hStocks[internalid] === "undefined") {

						// 		var script = "/app/site/hosting/scriptlet.nl?script=412&deploy=2&compid=1120086&h=b5bee5129e24e81ca671&custparam_id=";
						// 		hStocks[internalid] = stock;
						// 		jQuery.ajax({
						// 			dataType: "json",
						// 			url: script + internalid,
						// 			success: function (res) {
						// 				if (res.success) {
						// 					hStocks[internalid] = res.quantity;
						// 					for (var i in hRenders) {
						// 						hRenders[i] && hRenders[i].render();
						// 					}
						// 				} else {
						// 					hStocks[internalid] = stock;
						// 				}
						// 			}
						// 		});
						// 	} else {
						// 		return hStocks[internalid];
						// 	}
						// }

					}
					return stock;
				}

				var Configuration = require('Configuration');
				if (Configuration.Configuration) {
					Configuration = Configuration.Configuration;
				}

				function addNameToHeader(item,header){
					var custitem_c25_search_oems = item.get("custitem_c25_search_oems");
// console.log("custitem_c25_search_oems",custitem_c25_search_oems);
					if (custitem_c25_search_oems) {
						if (typeof (custitem_c25_search_oems) == "string") {
							custitem_c25_search_oems = JSON.parse(custitem_c25_search_oems);
						}
						if (custitem_c25_search_oems.preferred) {
							var name = custitem_c25_search_oems.preferred.name;
							if (name) {
								var lheader = header.toLowerCase();
								var lnames = name.toLowerCase().split(" ");
								var found;
								
								for (var i = 0; i<lnames.length; i++) {
									if (lheader.indexOf(lnames[i]) > -1) {
										found = true;
										break;
									}
								}
								if (!found) {
									header = name + " " + header;
								}
							}
						}
					}
					return header;
				}
				Configuration.itemKeyMapping = _.extend(Configuration.itemKeyMapping || {}, {
					_stock: function (item) {
						return quantityavailable(item);
					}, quantityavailable: function (item) {
						return quantityavailable(item);
					},
					_isInStock: function (item) {
						return quantityavailable(item) > 0;
					},
					_showOutOfStockMessage: function (item) {
						return quantityavailable(item) == 0;
					}, _showInStockMessage: function (item) {
						return quantityavailable(item) > 0;
					},
					_pageHeader: function (item) {

						return addNameToHeader(item,item.get("storedisplayname2") || item.get("displayname") || "");
					
					},
					_name: function(item) {
						// If its a matrix child it will use the name of the parent
						var item_id = item.get('itemid') || '';
						var parent = item.get('_matrixParent');
						if (parent.get('internalid')) {
							// we need the displayname included in the itemdid, see #B-11868
							var matches = item_id.match(/:(.*)/);
							var child_name = matches && matches[1];
							return addNameToHeader(parent,
								child_name ||
								parent.get('storedisplayname2') ||
								parent.get('displayname') ||
								item_id
							);
						}
		
						// Otherwise return its own name
						return addNameToHeader(item,item.get('storedisplayname2') || item.get('displayname') || item_id);
					}
					,_isPurchasable: function(item) {
						return item.get("ispurchasable")&&!item.get("dontshowprice");
					 }
					 // 'ispurchasable'

				});
				//quick-add-item-results
				if (SC.ENVIRONMENT.SCTouchpoint == "shopping") {
					var ProductDetailsFullView = require("ProductDetails.Full.View");
					if (ProductDetailsFullView) {

						_.extend(ProductDetailsFullView.prototype, {

							initialize: _.wrap(ProductDetailsFullView.prototype.initialize, function (initialize) {
								var res = initialize.apply(this, _.rest(arguments));
								hRenders[this.cid] = this;
								return res;
							})
							, destroy: function destroy() {
								delete hRenders[this.cid];
								this._destroy();
							}
						});
					}

					ProductDetailsFullView = require("ProductDetails.QuickView.View");
					if (ProductDetailsFullView) {

						_.extend(ProductDetailsFullView.prototype, {

							initialize: _.wrap(ProductDetailsFullView.prototype.initialize, function (initialize) {
								var res = initialize.apply(this, _.rest(arguments));
								hRenders[this.cid] = this;
								return res;
							})
							, destroy: function destroy() {
								delete hRenders[this.cid];
								this._destroy();
							}
						});
					}
				}
				var ProductLineStockView = require("ProductLine.Stock.View");
				if (ProductLineStockView) {
					_.extend(ProductLineStockView.prototype, {

						initialize: _.wrap(ProductLineStockView.prototype.initialize, function (initialize) {
							var res = initialize.apply(this, _.rest(arguments));
							hRenders[this.cid] = this;
							return res;
						})
						, destroy: function destroy() {
							delete hRenders[this.cid];
							this._destroy();
						}, getContext: _.wrap(ProductLineStockView.prototype.getContext, function (getContext) {

							var res = getContext.apply(this, _.rest(arguments));

							if (SC.ENVIRONMENT.SCTouchpoint == "checkout") {
								var qa = quantityavailable(this.model);
								res.showInStockMessage = qa > 0;
								res.showOutOfStockMessage = qa == 0;
								res.stockInfo.isInStock = qa > 0;
								res.stockInfo.stock = qa;
								res.stockInfo.showInStockMessage = qa > 0;
								res.stockInfo.showOutOfStockMessage = qa == 0;
							}
							return res;
						})
					});
				}



			}
		};
	});
